exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".work-queue .action-button-group{margin:0;align-content:flex-start;justify-content:flex-start;flex-flow:unset;padding:0 5px}.work-queue .div-table-cell span.cell:nth-child(2){display:block;font-style:italic;font-size:11.5px;padding-top:6px;font-weight:500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/MyWorkQueue/MyWorkQueue.scss
// module id = 867
// module chunks = 0